var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.05 14.05C14.2985 13.8015 14.7015 13.8015 14.95 14.05L17.8136 16.9137C18.0621 17.1622 18.0621 17.5651 17.8136 17.8136C17.5651 18.0621 17.1622 18.0621 16.9137 17.8136L14.05 14.95C13.8015 14.7015 13.8015 14.2985 14.05 14.05Z",
    fill: "#172B4D",
    stroke: "#172B4D",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 10.3636C4 6.8491 6.8491 4 10.3636 4C13.8782 4 16.7273 6.8491 16.7273 10.3636C16.7273 13.8782 13.8782 16.7273 10.3636 16.7273C6.8491 16.7273 4 13.8782 4 10.3636ZM10.3636 5.27273C7.55201 5.27273 5.27273 7.55201 5.27273 10.3636C5.27273 13.1753 7.55201 15.4546 10.3636 15.4546C13.1753 15.4546 15.4546 13.1753 15.4546 10.3636C15.4546 7.55201 13.1753 5.27273 10.3636 5.27273Z",
    fill: "#172B4D",
    stroke: "#172B4D",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.56ec3fcc558f0e7864a767efdce9d337.svg";
export { ForwardRef as ReactComponent };